import React from 'react';
import PropTypes from 'prop-types';

import { Card, CardTitle } from 'components/Card';
import { Fieldset } from 'components/Form';
import { Form, RadioButton, RadioGroup } from 'components/HookForm';
import Message from 'components/Message';

import { messages } from './ChangeLanguageSection.messages';

export const ChangeLanguageSection = ({ languages, currentLocale, handleChangeLocale }) => {
  const handleLocaleSelect = event => handleChangeLocale(event.target.value);

  return (
    <Card>
      <Message as={CardTitle} message={messages.title} />
      <div className="grid grid--rev">
        <div className="grid__item md-2/3">
          <div className="md-ml+">
            <div className="mb+">
              <Message as="h5" className="epsilon mb-" message={messages.translation} />
              <Message as="p" message={messages.translationDescription} />
            </div>
            <div>
              <Message as="h5" className="epsilon mb-" message={messages.additionalLanguages} />
              <Message as="p" message={messages.additionalLanguagesDescription} />
            </div>
          </div>
        </div>
        <div className="grid__item md-1/3">
          <Form defaultValues={{ locale: currentLocale }} onSubmit={() => {}}>
            <Fieldset>
              <RadioGroup name="locale" onChange={handleLocaleSelect}>
                {languages.map(({ id, name }) => (
                  <RadioButton key={id} value={id}>
                    {name && <Message message={name} />}
                  </RadioButton>
                ))}
              </RadioGroup>
            </Fieldset>
          </Form>
        </div>
      </div>
    </Card>
  );
};

ChangeLanguageSection.propTypes = {
  currentLocale: PropTypes.string,
  handleChangeLocale: PropTypes.func,
  languages: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.shape({
        id: PropTypes.string,
        defaultMessage: PropTypes.string,
      }),
    })
  ),
};
